// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-ImageWithCard----styles-module---wrapper---183Xu","imageWrapper":"src-components-ImageWithCard----styles-module---imageWrapper---2MijM","image":"src-components-ImageWithCard----styles-module---image---2KVpp","content":"src-components-ImageWithCard----styles-module---content---jeAhp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageWithCard/styles.module.css
// module id = 503
// module chunks = 168707334958949